export class ACL {
    constructor() {
        this.roles = [];
    }

    /**
     * @returns {string[]}
     */
    getRoleIds() {
        return this.roles.map((role) => role.name);
    }

    /**
     * @returns {string[]}
     */
    getRuleIds() {
        return [...new Set([].concat(...this.roles.map((role) => role.getResourceIds())))];
    }

    /**
     * @param {Role} role
     * @returns {Role}
     */
    addRole(role) {
        if (this.getRole(role.name)) {
            throw new Error(`Multiple definitions of "${role.name}" role`);
        }

        this.roles.push(role);

        return role;
    }

    /**
     * @param {string} name
     * @returns {Role}
     */
    getRole(name) {
        return this.roles.find((layer) => layer.name === name);
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    isGranted(request) {
        const role = this.getRole(request.role);

        if (!role) {
            return false;
        }

        return role.isGranted(request);
    }
}
